import { render, staticRenderFns } from "./PreviewNewImage.vue?vue&type=template&id=8b167a2e&scoped=true&"
import script from "./PreviewNewImage.vue?vue&type=script&lang=js&"
export * from "./PreviewNewImage.vue?vue&type=script&lang=js&"
import style0 from "./PreviewNewImage.vue?vue&type=style&index=0&id=8b167a2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b167a2e",
  null
  
)

export default component.exports